import * as React from "react";
import Button from "@mui/material/Button";
import DialogContentText from "@mui/material/DialogContentText";
import Box from "@mui/material/Box";
import { LoadingButton } from "@mui/lab";
import BaseModal from "./global/BaseModal";

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message?: string;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

const ConfirmModal = ({
  open,
  title,
  message,
  onClose,
  onConfirm,
}: ConfirmModalProps) => {
  const [loading, setLoading] = React.useState(false);

  const handleConfirm = React.useCallback(() => {
    setLoading(true);
    onConfirm().finally(() => {
      setLoading(false);
      onClose();
    });
  }, [onConfirm, onClose]);

  const footer = (
    <>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <LoadingButton
          onClick={handleConfirm}
          autoFocus
          loading={loading}
          variant={"contained"}
        >
          Confirm
        </LoadingButton>
    </>
  );

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={title}
      footer={footer}
      maxWidth="xs"
    >
      <Box sx={{ 
        p: { xs: 2, sm: 3 },
        "@media (orientation: landscape) and (max-width: 900px)": {
          p: { xs: 1.5, sm: 2 },
        },
      }}>
        <DialogContentText sx={{
          "@media (orientation: landscape) and (max-width: 900px)": {
            fontSize: "0.875rem",
            lineHeight: 1.5,
          },
        }}>
          {message || ""}
        </DialogContentText>
      </Box>
    </BaseModal>
  );
};
export default ConfirmModal;
